import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'mage-components';

import { Frame, IconStar, SpacerVertical, Typography } from '@klarna/bubble-ui';

import ExpandableFrame from './ExpandableFrame';

const componentPropTypes = {
  countryPlatforms: PropTypes.array.isRequired,
  selectedCountry: PropTypes.string.isRequired,
};

type ComponentProps = PropTypes.InferProps<typeof componentPropTypes>;

export const Platforms: React.FC<ComponentProps> = ({ countryPlatforms, selectedCountry }) => {
  const subComponentPropTypes = {
    platformType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };

  type SubComponentProps = PropTypes.InferProps<typeof subComponentPropTypes>;
  const PlatformsOfType: React.FC<SubComponentProps> = ({ platformType, title }) => (
    <ExpandableFrame title={title}>
      <Row>
        {countryPlatforms
          .filter(p => p.type === platformType)
          .map(p => (
            <Column columns={{ mobile: 3 }} key={p.key}>
              <SpacerVertical spaceToken="space/100" />
              <Typography textToken="text-style/text/paragraphs/body/bold">
                {p.label}
                {p?.standardOptionIn?.includes(selectedCountry) ? <IconStar /> : ''}
              </Typography>
              <Typography textToken="text-style/text/paragraphs/default/regular">
                {p.partner_override_id}
              </Typography>
            </Column>
          ))}
      </Row>
    </ExpandableFrame>
  );

  PlatformsOfType.propTypes = subComponentPropTypes;

  return (
    <Frame>
      <Row>
        <Column columns={{ mobile: 8 }}>
          <Typography textToken="text-style/headings/titles/bold/tertiary">Platforms</Typography>
        </Column>
      </Row>
      <PlatformsOfType platformType="SUPPORTED" title="Supported" />
      <PlatformsOfType platformType="NATIVE" title="Native Partner" />
      <PlatformsOfType platformType="MANUAL_CONTACT" title="Manual contact (sales)" />
      <PlatformsOfType
        platformType="WITHOUT_LANDING_PAGE"
        title="Not supported (Without landing page)"
      />
    </Frame>
  );
};

Platforms.propTypes = componentPropTypes;
